/**
 * Shown before a subject change is saved in the InMail Library — a template's subject or the
 * standard one. Open InMail drafts follow the Library subject, hand edits too (Sofia, Oct 26 2026).
 */
export const SUBJECT_OVERWRITE_WARNING =
  'Every InMail draft that is not sent yet gets the new subject — also drafts whose subject was changed by hand. Sent InMails stay as they are.\n\nSave anyway?';
